/*
  This function is exageratedly complicated and undigestable (CardWidth numbers seem random,
  there'are soooooooo many decision branches to only return a  boolean). I got it out of the main
  component to reduce complexity, spent a lot of personal time trying to add full test coverage to
  refactor it safely and it was all completely lost. Future adventure seeker, refactor warrior;
  instead of trying to do what I did, try to understand the original purpose of this function and
  find a way to get rid of it.
*/
// TODO: Add documentation
// TODO: Add tests
// TODO: refactor to minimize complexity
var areButtonsWrapped = function areButtonsWrapped(_ref) {
  var buttonCount = _ref.buttonCount,
      cardWidth = _ref.cardWidth,
      hasMedia = _ref.hasMedia,
      isChildCard = _ref.isChildCard,
      largeMedia = _ref.largeMedia,
      largeParent = _ref.largeParent,
      parentLabel = _ref.parentLabel,
      parentWrapped = _ref.parentWrapped,
      stackedButtons = _ref.stackedButtons;
  var buttonsWrapped = false;

  if (Number(buttonCount) === 2 && !stackedButtons) {
    if (!isChildCard) {
      if (hasMedia) {
        if (parentLabel) {
          if (largeMedia && cardWidth <= 1300) {
            buttonsWrapped = true;
          } else if (cardWidth <= 1170) {
            buttonsWrapped = true;
          }
        } else if (largeMedia && cardWidth <= 1150) {
          buttonsWrapped = true;
        } else if (!largeMedia && cardWidth <= 1116) {
          buttonsWrapped = true;
        }
      } else if (cardWidth <= 870) {
        buttonsWrapped = true;
      }
    } else {
      if (largeParent && cardWidth <= 1218) {
        buttonsWrapped = true;
      } else if (cardWidth <= 1088) {
        buttonsWrapped = true;
      }
    }
  } else if (buttonCount === 1 || stackedButtons) {
    if (!isChildCard) {
      if (hasMedia) {
        if (parentLabel) {
          if (largeMedia && cardWidth <= 1197) {
            buttonsWrapped = true;
          } else if (cardWidth <= 1067) {
            buttonsWrapped = true;
          }
        } else if (largeMedia && cardWidth <= 1047) {
          buttonsWrapped = true;
        } else if (!largeMedia && cardWidth <= 917) {
          buttonsWrapped = true;
        } else if (!hasMedia && cardWidth <= 767) {
          buttonsWrapped = true;
        }
      } else if (cardWidth <= 767) {
        buttonsWrapped = true;
      }
    } else {
      if (largeParent) {
        if (!parentWrapped && cardWidth <= 1115) {
          buttonsWrapped = true;
        } else if (cardWidth <= 965) {
          buttonsWrapped = true;
        }
      } else {
        if (!parentWrapped && cardWidth <= 985) {
          buttonsWrapped = true;
        } else if (largeMedia && hasMedia && cardWidth <= 859) {
          buttonsWrapped = true;
        } else if (cardWidth <= 835) {
          buttonsWrapped = true;
        }
      }
    }
  }

  return buttonsWrapped;
};

export { areButtonsWrapped };